import React, { useState, } from "react";
import Logo from "../components/tools/Logo";
import { useNavigate } from "react-router-dom";
import { useSignInUserMutation } from "../store/api/userAuthApi";

const userSignIn = {
  username: "",
  password: "",
};

export default function SignIn() {
  const [auth, setAuth] = useState(userSignIn);
  const [errors, setError] = useState('');
  const [SignInUser] = useSignInUserMutation();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  const handleSubmit = async (e) => {

    e.preventDefault();
    setLoading(true); 
    try {
      const response = await SignInUser(auth);
      console.log(response.error);
      if (response.data.status === 200) {

        setTimeout(() => {
            setLoading(false);
            localStorage.setItem("UserData", JSON.stringify(response.data.info));
          navigate("/");
          window.location.reload()
        }, 4000);
      } else {
        setTimeout(() => {
            setLoading(false);
          navigate("/signin");
        }, 4000);
        setError(response.error)
        setAuth(userSignIn)
      }
    } catch (error) {
      
      console.log(errors);
    } 
  };

  return (
    <>
      <div id="page-container" className="main-content-boxed">
        <main id="main-container">
          <div className="bg-images">
            <div className="row mx-0 bg-black-op">
              <div className="hero-static col-md-6 col-xl-8 d-none d-md-flex align-items-md-end">
                <div className="p-30 ">
                  <p className="font-size-h3 font-w600 text-white">
                  Our job is to make yours efficient.
                  </p>
                  <p className="font-italic text-white-op">
                    Copyright &copy; <span className="js-year-copy"></span>  Horyaal Software
                  </p>
                </div>
              </div>
              <div
                className="hero-static col-md-6 col-xl-4 d-flex align-items-center bg-white"
                // data-toggle="appear"
                // data-className="animated fadeInRight"
              >
                <div className="content content-full">
                  <div className="px-30 py-10">
                    <div className="content-header-item">
                      <Logo _width={160} />
                    </div>
                    <h1 className="h3 font-w700 mt-30 mb-10">
                      Welcome to Your Dashboard
                    </h1>
                    <h2 className="h5 font-w400 text-muted mb-0">Please sign in</h2>
                  </div>

                  <form
                    className="js-validation-signin px-30"
                    onSubmit={handleSubmit}
                  >
                    <div className="form-group row">
                      <div className="col-12">
                        <div className="form-material floating1">
                          <input
                           autoComplete="off"
                            type="text"
                            className="form-control"
                            id="login-username"
                            name="login-username"
                            value={auth.username}
                            onChange={(e) =>
                              setAuth({ ...auth, username: e.target.value })
                            }
                          />
                          <label for="login-username">Username</label>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-12">
                        <div className="form-material floating1">
                          <input
                          autoComplete="off"
                            type="password"
                            className="form-control"
                            id="login-password"
                            name="login-password"
                            value={auth.password}
                            onChange={(e) =>
                              setAuth({ ...auth, password: e.target.value })
                            }
                          />
                          <label for="login-password">Password</label>
                        </div>
                      </div>
                    </div>
                    {loading === false ?errors && <div className="text-danger">{errors}</div> : <></>}
                    <div className="form-group">
                        
                    <button
                        type="submit"
                        className="btn btn-sm btn-hero btn-alt-primary"
                        disabled={loading} 
                      >
                        {loading ? ( 
                          <span>
                            <i className="fa fa-spinner fa-spin mr-2"></i>
                            Signing In...
                          </span>
                        ) : (
                          <span>
                            <i className="si si-login mr-2"></i> Sign In
                          </span>
                        )}
                      </button>
                     
                    </div>
                   
                  </form>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}
